import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: true,
    imports: [NgClass, MatFormFieldModule, MatSelectModule, FormsModule, NgxIntlTelInputModule, NgFor, MatOptionModule, NgIf]
})
export class PaginationComponent implements OnInit {

  // Permet de savoir s'il reste des items à display après ceux déjà dispay. Défaut false.
  @Input() hasMore:boolean = false;
  // La page actuelle. Défaut 0.
  @Input() page: number = 0;
  // Le nombre de page maximum. Défaut 0.
  @Input() maxPage: number = 0;
  // Définit le nombre d'item par page. Défaut 10.
  @Input() perPage:string = '10';

  // Renvoi "next" ou "previous" selon le bouton qui a été cliqué.
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  // Renvoi le nombre d'élément à afficher par page. Peut renvoyer "all" !
  @Output() perPageEmitter: EventEmitter<number | string> = new EventEmitter<number | string>();


  public perPageArray: string[] = ['10', '25', '50', '100', 'All'];

  constructor() { }

  ngOnInit(): void {
  }


  public toChangePage(direction) :void {
    this.changePage.emit(direction);
  }

  public changePerPage(value):void {
    this.perPageEmitter.emit(value);
  }


}
